const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Variant image fix: when a variant is picked, custom.js changes the main image src,
   but the old srcset stays and the browser keeps showing the old picture.
   This rebuilds the srcset from the new src so the right variant image shows. */
(function () {
  function fixSrcset(img) {
    var src = img.getAttribute('src');
    if (!src) return;
    var file = src.split('?')[0].split('/').pop();
    var srcset = img.getAttribute('srcset') || '';
    if (srcset.indexOf(file) !== -1) return;
    var clean = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    var sep = clean.indexOf('?') > -1 ? '&' : '?';
    img.setAttribute(
      'srcset',
      [300, 400, 500, 600, 700, 800, 1000, 1200, 1400]
        .map(function (w) { return clean + sep + 'width=' + w + ' ' + w + 'w'; })
        .join(', ')
    );
  }
  function init() {
    document.querySelectorAll('.product-gallery__media-list').forEach(function (list) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'src' && m.target.tagName === 'IMG') fixSrcset(m.target);
        });
      }).observe(list, { attributes: true, subtree: true, attributeFilter: ['src'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
